import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { DashboardLayout } from "component/layout/dashboard";
import { PageProps } from "shared/page-props";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { styles } from "./style";
import * as env from "shared/env";

const mapStateToProps = (state: RootState) => {
	return {
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
}, dispatch);

interface Props extends
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>,
	PageProps,
	WithStyles<typeof styles> {
}

class Component extends React.Component<Props> {
	public render() {
		const { classes = {} } = this.props;
		const trainingWebinars = "https://www.ihomefinder.com/resources/support/training-webinars/";
		const learningContent = "https://www.ihomefinder.com/resources/support/#content";
		const contactSupport = "https://www.ihomefinder.com/resources/support/#contact";
		return (
			<DashboardLayout
				fullScreen={false}
				permitted={true}
				title="Support Center"
			>
				<Mui.Grid container direction="column" spacing={2}>
						<Mui.Grid item>
							<Mui.Typography className={classes.sfHeaderTitle}>
								Support Center
							</Mui.Typography>
							<Mui.Typography className={classes.sfHeaderSubtitle}>
								Everything you need to get the most value from your account.
							</Mui.Typography>
						</Mui.Grid>
						<Mui.Grid item>
					<Mui.Paper className={classes.sfCardContainer} elevation={0}>
						<Mui.Grid container>
							<Mui.Grid item xs>
								<Mui.Grid container direction="column" justifyContent="space-between" wrap="nowrap" className={classes.sfCardInner}>
									<Mui.Grid item>
										<Mui.Grid container direction="column" spacing={2} alignItems="center">
											<Mui.Grid item>
												<div className={classes.sfIconCircle}>
													<FeatherIcon className={classes.sfIcon}>
														<Icons.Tv />
													</FeatherIcon>
												</div>
											</Mui.Grid>
											<Mui.Grid item>
												<Mui.Typography align="center" className={classes.sfCardTitle}>
													Training Webinars
												</Mui.Typography>
											</Mui.Grid>
											<Mui.Grid item>
												<Mui.Typography align="center" className={classes.sfCardDescription}>
													Live training webinars and recordings
												</Mui.Typography>
											</Mui.Grid>
										</Mui.Grid>
									</Mui.Grid>
									<Mui.Grid item className={classes.sfButtonWrapper}>
										<Mui.Button
											variant="contained"
											disableElevation
											className={classes.sfButton}
											href={trainingWebinars}
											target="_blank"
											endIcon={<FeatherIcon fontSize="small"><Icons.ExternalLink /></FeatherIcon>}
										>
											View Schedule
										</Mui.Button>
									</Mui.Grid>
								</Mui.Grid>
							</Mui.Grid>
							<Mui.Grid item xs className={classes.sfCardBorderLeft}>
								<Mui.Grid container direction="column" justifyContent="space-between" wrap="nowrap" className={classes.sfCardInner}>
									<Mui.Grid item>
										<Mui.Grid container direction="column" spacing={2} alignItems="center">
											<Mui.Grid item>
												<div className={classes.sfIconCircle}>
													<FeatherIcon className={classes.sfIcon}>
														<Icons.BookOpen />
													</FeatherIcon>
												</div>
											</Mui.Grid>
											<Mui.Grid item>
												<Mui.Typography align="center" className={classes.sfCardTitle}>
													Learning Content
												</Mui.Typography>
											</Mui.Grid>
											<Mui.Grid item>
												<Mui.Typography align="center" className={classes.sfCardDescription}>
													Quick start guides, knowledge base, videos, and more
												</Mui.Typography>
											</Mui.Grid>
										</Mui.Grid>
									</Mui.Grid>
									<Mui.Grid item className={classes.sfButtonWrapper}>
										<Mui.Button
											variant="contained"
											disableElevation
											className={classes.sfButton}
											href={learningContent}
											target="_blank"
											endIcon={<FeatherIcon fontSize="small"><Icons.ExternalLink /></FeatherIcon>}
										>
											View Resources
										</Mui.Button>
									</Mui.Grid>
								</Mui.Grid>
							</Mui.Grid>
							<Mui.Grid item xs className={classes.sfCardBorderLeft}>
								<Mui.Grid container direction="column" justifyContent="space-between" wrap="nowrap" className={classes.sfCardInner}>
									<Mui.Grid item>
										<Mui.Grid container direction="column" spacing={2} alignItems="center">
											<Mui.Grid item>
												<div className={classes.sfIconCircle}>
													<FeatherIcon className={classes.sfIcon}>
														<Icons.MessageSquare />
													</FeatherIcon>
												</div>
											</Mui.Grid>
											<Mui.Grid item>
												<Mui.Typography align="center" className={classes.sfCardTitle}>
													Contact Support
												</Mui.Typography>
											</Mui.Grid>
											<Mui.Grid item>
												<Mui.Typography align="center" className={classes.sfCardDescription}>
													Need more help? Just ask.
												</Mui.Typography>
											</Mui.Grid>
										</Mui.Grid>
									</Mui.Grid>
									<Mui.Grid item className={classes.sfButtonWrapper}>
										<Mui.Button
											variant="contained"
											disableElevation
											className={classes.sfButton}
											href={contactSupport}
											target="_blank"
											endIcon={<FeatherIcon fontSize="small"><Icons.ExternalLink /></FeatherIcon>}
										>
											Contact Us
										</Mui.Button>
									</Mui.Grid>
								</Mui.Grid>
							</Mui.Grid>
						</Mui.Grid>
					</Mui.Paper>
						</Mui.Grid>
					</Mui.Grid>
			</DashboardLayout>
		)
	}
}

export const SupportCenterPage = withStyles(connect(mapStateToProps, mapDispatchToProps)(Component), styles);
